export const handleAmountCalc = (operatorTokensToBePurchased) => {
    const getTotalAmountForEachData = operatorTokensToBePurchased.map(
        (data) => data.units * data.amount
    );

    const totalAmount = getTotalAmountForEachData.reduce(function (
        accumulator,
        currentValue
    ) {
        return accumulator + currentValue;
    },
        0);
    return totalAmount;
}



// Helper to check if the token is expired
export const isTokenExpired = (token) => {
    try {
      // Decode token payload (assumes JWT) and check 'exp' field
      const { exp } = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000); // current time in seconds
      return now >= exp; // true if token is expired
    } catch (error) {
      console.error("Failed to decode token:", error);
      return true; // assume expired if decoding fails
    }
  };

  

  